import IMask from 'imask';
import { isUndefined } from '@philips-internal/oswald-ui-utils';
const noopValidate = () => true;
function createMask(mask) {
    return typeof mask === 'string'
        ? new IMask.MaskedPattern({ lazy: true, mask })
        : new IMask.MaskedRegExp({ mask });
}
function isNullOrUndefined(value) {
    return isUndefined(value) || value === null;
}
function createAlphanumericFormatter(options) {
    const { name, mask, validate: customValidate = noopValidate, invalidMessage = '' } = options;
    function format(value) {
        if (isNullOrUndefined(value)) {
            return value;
        }
        const masked = createMask(mask);
        masked.unmaskedValue = String(value);
        return masked.value;
    }
    function parse(value) {
        const masked = createMask(mask);
        masked.value = String(value);
        return masked.unmaskedValue;
    }
    function validate(value) {
        const message = invalidMessage;
        if (isNullOrUndefined(value)) {
            return [{ message, name, valid: true }];
        }
        const masked = createMask(mask);
        masked.value = String(value);
        const isMaskValid = Boolean(masked.isComplete && masked.doValidate({}));
        const isCustomValid = customValidate(value);
        const isValid = isMaskValid && isCustomValid;
        return [{
                message,
                name,
                valid: isValid,
            }];
    }
    function getPattern() {
        return mask;
    }
    return {
        format,
        getPattern,
        parse,
        validate,
    };
}
export default createAlphanumericFormatter;
//# sourceMappingURL=alphanumeric-formatter.js.map